export default {"src":"/_next/static/media/parking.ab9085af.svg","height":27,"width":28,"blurWidth":0,"blurHeight":0};